import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "google-maps-container smph-hden" }
const _hoisted_2 = { class: "legend cf" }
const _hoisted_3 = { class: "item cf" }
const _hoisted_4 = { class: "fl-l text" }
const _hoisted_5 = { class: "item cf" }
const _hoisted_6 = { class: "fl-l text" }
const _hoisted_7 = { class: "item cf" }
const _hoisted_8 = { class: "fl-l text" }
const _hoisted_9 = { class: "item cf" }
const _hoisted_10 = { class: "fl-l text" }
const _hoisted_11 = { class: "item cf" }
const _hoisted_12 = { class: "fl-l text" }

import Localizer from '@Scripts/Common/Localizer';
import GoogleMapsHelper from '@Scripts/Infrastructure/GoogleMapsHelper';


export default /*@__PURE__*/_defineComponent({
  __name: 'Locator',
  setup(__props) {

const localizer = Localizer;
const googleMapsHelper = GoogleMapsHelper;

(async () => {
    await googleMapsHelper.loadMap();
})()

getGeoMarkers();

function getGeoMarkers() {
    const markerElements = document.querySelectorAll('.google-maps-marker');
    markerElements.forEach((element: any, i: number) => {
        const markerIcon = element.querySelector('input[name="MarkerIcon"]')?.value;
        const markerLatitude = element.querySelector('input[name="Latitude"]')?.value;
        const markerLongitude = element.querySelector('input[name="Longitude"]')?.value;
        const markerTitle = element.querySelector('input[name="MarkerTitle"]')?.value;
        const markerContents = element.querySelector('.infowindow')?.innerHTML;
        const icon = markerIcon && markerIcon.trim().length > 0 ? markerIcon : 'gmaps-marker-sedi@2x.png';

        const latlng = new (window as any).google.maps.LatLng(Number(markerLatitude), Number(markerLongitude));
        googleMapsHelper.addMarker(i.toString(), markerTitle, markerContents, latlng.lat(), latlng.lng(), icon);
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", {
      id: "GoogleMaps",
      class: "google-maps"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sprite-icon-sedi fl-l" }, null, -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(localizer).get("App.Common.Locations")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "sprite-icon-filialeitaliana fl-l" }, null, -1)),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(localizer).get("App.Common.ItalianBranch")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sprite-icon-vlsfilialeestera fl-l" }, null, -1)),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(localizer).get("App.Common.VLSForeignBranch")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sprite-icon-vlsterminal fl-l" }, null, -1)),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(localizer).get("App.Common.VLSTerminal")), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "sprite-icon-vlsbranch fl-l" }, null, -1)),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(localizer).get("App.Common.VLSBranch")), 1)
      ])
    ])
  ]))
}
}

})